/*
import { Directive } from '@angular/core';

@Directive({
  selector: '[pmZipCode]'
})
export class ZipCodeDirective {

  constructor() { }

}
*/
import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[pmZipCode]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: ZipCodeDirective,
      multi: true,
    },
  ],
})
export class ZipCodeDirective implements Validator {
  private zipCodePattern = /^\d{5}(?:[-\s]?\d{4})?$/; // Validates both 5-digit and ZIP+4 format

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  // Prevent non-numeric input
  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    const key = event.key;

    // Allow control keys like Backspace, Tab, etc.
    if (allowedKeys.includes(key) || (event.ctrlKey && (key === 'a' || key === 'c' || key === 'v'))) {
      return;
    }

    // Prevent non-numeric input
    if (!/^\d$/.test(key)) {
      event.preventDefault();
    }
  }

  // Handle input changes to auto-format the ZIP code
  @HostListener('input', ['$event']) onInputChange(event: any) {
    let value = event.target.value.replace(/\D+/g, ''); // Remove non-numeric characters
    if (value.length > 5) {
      value = `${value.substring(0, 5)}-${value.substring(5, 9)}`; // Format as ZIP+4 if necessary
    }
    this.renderer.setProperty(this.el.nativeElement, 'value', value);
  }

  // Validator to ensure the ZIP code matches the pattern
  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) {
      return null; // If no value, skip validation
    }

    const isValidZip = this.zipCodePattern.test(value);
    return isValidZip ? null : { invalidZipCode: true };
  }
}
